import request from '@/utils/request'
// 人员培训
export function PersonTraining(data) {
    return request({
        url:'/netbar/api/train_video_link/v1/get_list',
        method:'post',
        data
    })
}
//  用户答题状态和答题记录
export function UserAnswerState(data) {
    return request({
        url:'/netbar/api/personnel_inspection/v1/select_user_answer_state',
        method:'post',
        data
    })
}
// 题库联系题
export function Exercises(data) {
    return request({
        url:'/netbar/api/personnel_inspection/v1/question_bank_list',
        method:'post',
        data
    })
}
// 模拟考试
export function PracticeTest(data) {
    return request({
        url:'/netbar/api/personnel_inspection/v1/practice_test',
        method:'post',
        data
    })
}
// 增加考试记录
export function AdditionRecord(data) {
    return request({
        url:'/netbar/api/personnel_inspection/v1/insert_exam_records',
        method:'post',
        data
    })
}
// 获取考试记录
export function gainitionRecord(data) {
    return request({
        url:'/netbar/api/personnel_inspection/v1/exam_records_list',
        method:'post',
        data
    })
}